import { Injectable } from '@angular/core';
import { empty, Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';

import { SupplierUser } from '../models/supplier-user';

// services
import { WebApiService } from '../../../shared/services/web-api.service';

class UserFilter {
  showActive = true;
  showInactive = true;
  showBlocked = true;
  showPending = true;
}

@Injectable()
export class SupplierUserService {

  private apiPath: string;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'supplierlevel';
  }

  private appendToUrl(url: string, field: string, value: any): string {

    if (url) {
      url += `&${field}=${value}`;
    } else {
      url = `?${field}=${value}`;
    }
    return url;
  }

  getUsersFiltered(supplierId: number, userFilter: UserFilter): Observable<Array<SupplierUser>> {

    let url: string;

    if (!userFilter) {
      return empty();
    }

    // build url on applied filter:
    if (userFilter.showActive !== null) {
      url = this.appendToUrl(url, 'ShowActive', userFilter.showActive);
    }
    if (userFilter.showInactive !== null) {
      url = this.appendToUrl(url, 'ShowInactive', userFilter.showInactive);
    }
    if (userFilter.showBlocked !== null) {
      url = this.appendToUrl(url, 'ShowBlocked', userFilter.showBlocked);
    }
    if (userFilter.showPending !== null) {
      url = this.appendToUrl(url, 'ShowPending', userFilter.showPending);
    }

    return this.webApiService.getList(this.apiPath + '/' + supplierId + '/user/filter' + url);
  }

  getUser(supplierId: number, userId: number): Observable<SupplierUser> {
    return this.webApiService.get(this.apiPath + '/' + supplierId + '/user', userId);
  }

  // save(auctionClusterId: number, user: AuctionClusterUser): Observable<any> {
  //   return this.webApiService.save<AuctionClusterUser>(this.apiPath + '/' + auctionClusterId + '/user', user);
  // }

  edit(supplierId: number, user: SupplierUser) {
    return this.webApiService.editSingle<SupplierUser>(this.apiPath + '/' + supplierId + '/user', user);
  }

  // enableDisable(auctionClusterId: number, user: AuctionClusterUser): Observable<AuctionClusterUser> {
  //   if (user.isActive) {
  //     return this.webApiService.enableDisable(this.apiPath + '/' + auctionClusterId + '/user/disable', user.userId);
  //   } else {
  //     return this.webApiService.enableDisable(this.apiPath + '/' + auctionClusterId + '/user/enable', user.userId);
  //   }
  // }

  delete(supplierId: number, userId: number): Observable<any> {
    return this.webApiService.delete(this.apiPath + '/' + supplierId + '/user', userId);
  }

  verifyEmail(supplierId: number, email: string): Observable<any> {
    return this.webApiService.verifyEmail(this.apiPath + '/' + supplierId + '/user/verify', email);
  }
}
